/**
 * Front page "Latest Work": dual-direction marquee with pause on hover and arrows.
 */
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.work-marquee-track-custom').forEach(function (track) {
        var marquee = track.closest('.work-marquee');
        var firstItem = track.querySelector('.work-item');
        if (!marquee || !firstItem) return;

        var speed = 0.8;
        var currentPos = 0;
        var isLTR = marquee.classList.contains('work-marquee--ltr');
        var trackWidth = track.offsetWidth / 2;
        var isPaused = false;
        var scrollStep = firstItem.offsetWidth + 30; // 30 is the gap

        function render() {
            track.style.transform = 'translate3d(' + currentPos + 'px, 0, 0)';
        }

        if (isLTR) currentPos = -trackWidth;

        (function scroll() {
            if (!isPaused) {
                if (isLTR) {
                    currentPos += speed;
                    if (currentPos >= 0) currentPos -= trackWidth;
                } else {
                    currentPos -= speed;
                    if (currentPos <= -trackWidth) currentPos += trackWidth;
                }
                render();
            }
            requestAnimationFrame(scroll);
        })();

        marquee.addEventListener('mouseenter', function () { isPaused = true; });
        marquee.addEventListener('mouseleave', function () { isPaused = false; });

        var prevBtn = marquee.querySelector('.marquee-prev');
        var nextBtn = marquee.querySelector('.marquee-next');
        if (prevBtn && nextBtn) {
            prevBtn.addEventListener('click', function (e) {
                e.preventDefault();
                currentPos += scrollStep;
                if (currentPos > 0) currentPos -= trackWidth;
                render();
            });
            nextBtn.addEventListener('click', function (e) {
                e.preventDefault();
                currentPos -= scrollStep;
                if (currentPos <= -trackWidth) currentPos += trackWidth;
                render();
            });
        }
    });
});
